import {
  useMutation,
} from '@tanstack/react-query';
import {
  UserSettingDTO,
} from 'dtos';
import usePrefetchedData from 'pages/Dashboard/hooks/usePrefetchedData';
import {
  getApiSettingsGetOrCreateUserSettings,
  postApiSettingsCreateOrUpdateUserSettings,
} from 'endpoints';

export function useGetUserSettings() {
  const { data, isLoading } = usePrefetchedData<UserSettingDTO>({
    key: ['user-view-settings'],
    defaultValue: {},
    fetchFn: getApiSettingsGetOrCreateUserSettings,
  });

  return {
    data,
    isLoading,
  };
}

export function useUpsertUserSettings() {
  return useMutation<UserSettingDTO, Error, UserSettingDTO>({
    mutationFn: (settings) => postApiSettingsCreateOrUpdateUserSettings(settings),
    mutationKey: ['user-view-settings'],
  });
}
